export default "__VITE_ASSET__Ba8Cx$1Z__"